import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { LinkButton } from 'rc-easyui';

import { setStatusValue } from '../../actions/Project/ProjectListAction';

import { setIsShowFindAllViewList } from '../../actions/transOperationActions';

import {
  setIsShowFindAllViewInput,
  setIsShowFindAllViewReplace,
} from '../../actions/transOperation_find_Actions';
import {
  setCreateMutileData,
  addNewMultipleFindData,
} from '../../actions/find/mutileFindAction';
import { ButtonGroup, FileButton } from '../translations/objects/SelectFiles';

class MultipleFindView_create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tmpMultipleFindData: {
        title: 'untitled',
        items: [],
      }, //臨時內容

      isShowFindForm: false,
      isShowSavaChangeForm: false, //儲存視窗

      //新增輸入
      inputFind: '',
      inputPlace: '',
      inputTitle: 'untitled',
    };

    this.addItem = this.addItem.bind(this);
  }

  async addItem() {
    let newtmpMultipleFindData = this.state.tmpMultipleFindData;

    let items = newtmpMultipleFindData.items;

    items.push({
      findText: this.state.inputFind,
      replaceText: this.state.inputPlace,
    });

    this.setState({ tmpMultipleFindData: newtmpMultipleFindData });
    this.setState({ inputFind: '' });
    this.setState({ inputPlace: '' });
  }

  async componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
    if (nextProps.findOperation) {
    }
  }

  async setShowFindForm(result) {
    await this.setState({ isShowFindForm: result });
  }

  async setSaveChangeForm(result) {
    await this.setState({ isShowSavaChangeForm: result });
  }

  render() {
    let {
      isShowCreate,
      isShowFindForm,
      isShowSavaChangeForm,
      isCreateOne,
      currEditIndex,
      tmpMultipleFindData,
      inputTitle,
    } = this.state;

    let mainContent;

    //物件群
    let itemsArray = null;
    if (tmpMultipleFindData.items.length !== 0) {
      let items = tmpMultipleFindData.items;
      itemsArray = items.map((request, index) => {
        const { findText, replaceText } = request;

        return (
          <tr key={index}>
            <td>
              <button className='text-primary' onClick={() => {}}>
                {findText}
              </button>
            </td>
            <td>{replaceText}</td>
            <td>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => {}}
              >
                Remove
              </button>
            </td>
          </tr>
        );
      });
    }

    mainContent = (
      <div>
        <table className='table'>
          <thead>
            <tr>
              <th scope='col'>Find</th>
              <th scope='col'>Replace with</th>
            </tr>
          </thead>
          <tbody>{itemsArray}</tbody>
        </table>

        <div style={{ marginBottom: '20px' }}>
          <LinkButton
            onClick={() => {
              this.setShowFindForm(true);
              this.setSaveChangeForm(false);
            }}
          >
            Add item
          </LinkButton>
          <LinkButton
            onClick={() => {
              this.setShowFindForm(false);
              this.setSaveChangeForm(true);

              //是新增
              this.setState({ isCreateOne: true });
            }}
          >
            Save Changes
          </LinkButton>
        </div>

        {/* 新增物件視窗 */}
        {isShowFindForm && (
          <form className='p-3' style={{ backgroundColor: '#EEEEEE' }}>
            <div className='form-group'>
              <label htmlFor='inputAddress'>Find:</label>
              <input
                type='text'
                className='form-control'
                id='inputAddress'
                placeholder=' '
                value={this.state.inputFind}
                onChange={(event) =>
                  this.setState({ inputFind: event.target.value })
                }
              />
            </div>
            <div className='form-group'>
              <label htmlFor='inputAddress2'>Replace with:</label>
              <input
                type='text'
                className='form-control'
                id='inputAddress2'
                placeholder=' '
                value={this.state.inputPlace}
                onChange={(event) =>
                  this.setState({ inputPlace: event.target.value })
                }
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <LinkButton
                onClick={() => {
                  //新增
                  this.addItem();
                }}
              >
                Add item
              </LinkButton>
              <LinkButton onClick={() => this.setShowFindForm(false)}>
                Cancel
              </LinkButton>
            </div>
          </form>
        )}

        {/* 儲存視窗 */}
        {isShowSavaChangeForm && (
          <form className='p-3' style={{ backgroundColor: '#EEEEEE' }}>
            <div className='form-group'>
              <label htmlFor='inputAddress'>Name:</label>
              <input
                type='text'
                className='form-control'
                id='inputTitle'
                placeholder=' '
                value={this.state.inputTitle}
                onChange={async (event) => {
                  await this.setState({ inputTitle: event.target.value });
                }}
              />
            </div>
            <div style={{ marginBottom: '20px' }}>
              <LinkButton
                onClick={() => {
                  //新資料
                  let newtmpMultipleFindData = tmpMultipleFindData;
                  //改名稱
                  newtmpMultipleFindData.title = inputTitle;

                  //進行儲存
                  this.props.addNewMultipleFindData(
                    this.props.findOperation.multipleFindData,
                    newtmpMultipleFindData
                  );

                  this.props.setCreateMutileData(false);
                }}
              >
                Save
              </LinkButton>
              <LinkButton onClick={() => this.setShowFindForm(false)}>
                Cancel
              </LinkButton>
            </div>
          </form>
        )}

        <hr />
        <LinkButton onClick={() => this.setShowCreate(false)}>
          Replace
        </LinkButton>
        <div className='form-check'>
          <input
            className='form-check-input'
            type='checkbox'
            value=''
            id='defaultCheck1'
          />
          <label className='form-check-label' htmlFor='defaultCheck1'>
            Case Sensitive
          </label>
        </div>
        <LinkButton
          onClick={() => {
            //是新增
            this.props.setCreateMutileData(false);
          }}
        >
          Back to List
        </LinkButton>
        <hr />
        <div className='my-3 float-right'>
          <LinkButton
            style={{ width: 80 }}
            onClick={() => this.closeDialog(true)}
          >
            Close
          </LinkButton>
        </div>
      </div>
    );

    return mainContent;
  }
}

MultipleFindView_create.propTypes = {
  errors: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  setIsShowFindAllViewInput: PropTypes.func.isRequired,
  multipleFind: PropTypes.func.isRequired,
  findOperation: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
  errors: state.errors,
  transOperation: state.transOperation,
  findOperation: state.findOperation,
});

export default connect(mapStateToProps, {
  setStatusValue,
  setIsShowFindAllViewInput,
  setIsShowFindAllViewList,
  setIsShowFindAllViewReplace,
  setCreateMutileData,
  addNewMultipleFindData,
})(withRouter(MultipleFindView_create));



// WEBPACK FOOTER //
// ./src/components/multipleFind/MultipleFindView_create.js